import React from 'react';
import '../css/sg-footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        Plataforma{' '}
        <a
          href="https://www.sustaingrowth.pt"
          target="_blank"
          rel="noopener noreferrer"
        >
          SustainGrowth
        </a>{' '}
        - Desenvolvido por{' '}
        <a
          href="https://www.sfcolab.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          SFCOLAB
        </a>{' '}
        | @2024 Todos os direitos reservados.
      </p>
    </footer>
  );
};

export default Footer;
